/**
 * report-builder-api
 * API сервиса генерации отчетов
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Формат формирования отчета (не поддерживаются xml, json)
 */
export type FormatType = 'xlsx' | 'pdf' | 'html' | 'txt' | 'csv';

export const FormatType = {
    Xlsx: 'xlsx' as FormatType,
    Pdf: 'pdf' as FormatType,
    Html: 'html' as FormatType,
    Txt: 'txt' as FormatType,
    Csv: 'csv' as FormatType
};

